import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { HearingRequestDialogComponent } from './hearing-request-dialog.component';

@NgModule({
  declarations: [HearingRequestDialogComponent],
  imports: [CommonModule, TranslateModule, DialogModule, ButtonModule],
  exports: [HearingRequestDialogComponent],
})
export class HearingRequestDialogModule {}
